/*
 * Copyright (C) 2018 - 2026 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React from 'react';
import { Row, Col } from 'antd';
import styles from '../styles.module.css';
import {
  formatCurrency,
  NumberFormat,
} from '../../../../../services/utils/commonUtils';
import generationIcon from '../../../../../../public/images/generation.png';
import charges from '../../../../../../public/images/charges.png';
import consumption from '../../../../../../public/images/consumption.png';
import period from '../../../../../../public/images/period.png';
import totalAmount from '../../../../../../public/images/newtotal.png';

const GenerationCard = ({ item, t }) => {
  return (
    <div className={styles.consumptionCardContainer}>
      <div className={styles.cardHeaderNew}>
        <div className={styles.cardHeaderLabel}>{t('label_generation')}</div>
        <div>
          <img src={generationIcon} />
        </div>
      </div>
      <div className={styles.newWrapper}>
        <div className={styles.consumptionCardWrapper}>
          <Row gutter={[16, 12]} justify="space-around" align="top">
            {/* Period */}
            <Col className={styles.colitems} xs={24} sm={24} md={6} lg={6}>
              <div className={styles.consumptionCard}>
                <div className={styles.cardHeader}>
                  <img src={period} />
                </div>
                <div className={styles.cardHeaderTxt}>
                  <span className={styles.consumptionCardLabel}>
                    {t('label_PERIOD')}
                  </span>
                  <p className={styles.consumptionData}>
                    {item.from} {t('label_to')} {item.to}
                  </p>
                </div>
              </div>
            </Col>

            {/* Units */}
            <Col className={styles.colitems} xs={24} sm={24} md={6} lg={6}>
              <div className={styles.consumptionCard}>
                <div className={styles.cardHeader}>
                  <img src={consumption} />
                </div>
                <div className={styles.cardHeaderTxt}>
                  <span className={styles.consumptionCardLabel}>
                    {t('label_generation_units')}
                  </span>
                  <p className={styles.consumptionData}>
                    {`${NumberFormat(item.units)} ${t('label_kWh')}`}
                  </p>
                </div>
              </div>
            </Col>

            {/* Rate */}
            <Col xs={24} sm={24} md={6} lg={6}>
              <div className={styles.consumptionCard}>
                <div className={styles.cardHeader}>
                  <img src={charges} />
                </div>
                <div className={styles.cardHeaderTxt}>
                  <span className={styles.consumptionCardLabel}>
                    {t('label_rate')}
                  </span>

                  <p className={styles.consumptionData}>
                    {formatCurrency(item.rate)}
                  </p>
                </div>
              </div>
            </Col>

            {/* Total Price */}
            <Col className={styles.colitems} xs={24} sm={24} md={6} lg={6}>
              <div className={styles.consumptionCard}>
                <div className={styles.cardHeader}>
                  <img src={totalAmount} />
                </div>

                <div className={styles.cardHeaderTxt}>
                  <span className={styles.consumptionCardLabel}>
                    {t('label_total_price')}
                  </span>

                  <p className={styles.consumptionData}>
                    {formatCurrency(item.amount)}
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default GenerationCard;
